import _extends from "@babel/runtime/helpers/extends";
import { AutoComplete, Box, FormField, listItemSelectBuilder } from '@wix/design-system';
import React from 'react';
import { RuleListStatus } from '../../../types';
import { dataHooks } from '../../../utils/datahooks';
import { RuleFooter, RuleLayout } from '../../rule-layout';
import { DropdownFixerCompletedState } from './dropdown-fixer-completed-state';
import { useDropdownFixer } from './use-dropdown-fixer';
import { includesCaseInsensitive } from './utils';
const DROPDOWN_POPOVER_Z_INDEX = 9999;
export const DropdownFixer = _ref => {
  var _ruleFooterProps$subm;
  let {
    ruleResult,
    selected
  } = _ref;
  const {
    ruleFooterProps,
    value,
    tips,
    onSelectValue,
    description,
    options,
    searchValue,
    setSearchValue,
    fieldLabel,
    isEditMode,
    onEditClick,
    onClick
  } = useDropdownFixer(ruleResult, selected);
  const design = ruleResult.fixerProps.design;
  const {
    autoFocus
  } = ruleResult.fixerProps;
  const optionsForAutoComplete = options.map(_ref2 => {
    let {
      id,
      value: title
    } = _ref2;
    return listItemSelectBuilder({
      id,
      label: title,
      size: 'small',
      title
    });
  });
  return ruleResult.status === RuleListStatus.passed && !isEditMode ? /*#__PURE__*/React.createElement(DropdownFixerCompletedState, {
    dataHook: ruleResult.dataHook,
    description: description,
    key: ruleResult.id,
    ruleResult: ruleResult,
    onEditClick: onEditClick
  }) : /*#__PURE__*/React.createElement(RuleLayout, {
    description: description,
    design: design == null ? void 0 : design.ruleLayout
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: (design == null ? void 0 : design.formGap) ?? 'SP1'
  }, /*#__PURE__*/React.createElement(FormField, {
    dataHook: dataHooks.formFieldDropdownFixer(ruleResult.dataHook),
    label: fieldLabel
  }, /*#__PURE__*/React.createElement(AutoComplete, {
    autoFocus: autoFocus,
    dataHook: dataHooks.autoCompleteFieldDropdownFixer(ruleResult.dataHook),
    disabled: (_ruleFooterProps$subm = ruleFooterProps.submitButtonProps) == null ? void 0 : _ruleFooterProps$subm.showLoader,
    options: optionsForAutoComplete,
    popoverProps: {
      appendTo: 'window',
      zIndex: DROPDOWN_POPOVER_Z_INDEX
    },
    predicate: option => includesCaseInsensitive(option.label, searchValue.trim()),
    selectedId: value == null ? void 0 : value.id,
    size: "small",
    value: searchValue,
    onChange: event => setSearchValue(event.target.value),
    onOptionsShow: onClick,
    onSelect: option => {
      onSelectValue({
        id: option.id,
        value: option.label
      });
    }
  })), tips), /*#__PURE__*/React.createElement(RuleFooter, _extends({
    dataHook: ruleResult.dataHook,
    design: design == null ? void 0 : design.ruleFooter
  }, ruleFooterProps)));
};
//# sourceMappingURL=dropdown-fixer.js.map